import {createContext, FC, ReactNode, useContext} from 'react';

import type {AdvancedSearchResultsData} from '@mavismart_frontend/pages/tabs/advanced_search_form';

export type SearchResultContextValue = AdvancedSearchResultsData | undefined;

const SearchResultContext = createContext<SearchResultContextValue | undefined>(undefined);

interface SearchResultContextProviderProps {
  value: SearchResultContextValue;
  children: ReactNode;
}

export const SearchResultContextProvider: FC<SearchResultContextProviderProps> = props => {
  const {value, children} = props;
  return <SearchResultContext.Provider value={value}>{children}</SearchResultContext.Provider>;
};

export const useSearchResultContext = (): SearchResultContextValue => {
  return useContext(SearchResultContext);
};

SearchResultContextProvider.displayName = 'SearchResultContextProvider';
